<!--
 * @Author: Shen Kui
 * @LastEditTime: 2023-05-11 10:40:10
 * @Description:
-->
<template>
  <div>
    <div class="h-100 position-absolute" :style="{ height: height, top: top }" id="data-monitoring">
      <div class="w-100 h-100 content p-10">
        <div class="data-title position-relative">
          <div class="left-top-border"></div>
          <div class="fz-14 text-color-white p-l-20">环境监测</div>
          <i
            class="iconfont icon-close position-absolute cur_pointer text-color-white"
            @click="closeComponent"
          ></i>
        </div>
        <div class="env-monitoring w-100 p-20 position-relative">
          <el-row :gutter="10" class="h-100">
            <el-col :span="8" class="h-100">
              <el-card
                class="w-100 h-100 field-temp"
                :body-style="{ height: '100%', padding: '10px' }"
              >
                <div class="w-100">
                  <div class="w-100 tc fz-20">21℃</div>
                  <div class="w-100 tc fz-14">现场温度</div>
                </div>
              </el-card>
            </el-col>
            <el-col :span="8" class="h-100">
              <el-card
                class="w-100 h-100 field-humidity"
                :body-style="{ height: '100%', padding: '10px' }"
              >
                <div class="w-100">
                  <div class="w-100 tc fz-20">21%</div>
                  <div class="w-100 tc fz-14">现场湿度</div>
                </div>
              </el-card>
            </el-col>
            <el-col :span="8" class="h-100">
              <el-card
                class="w-100 h-100 field-wind-speed"
                :body-style="{ height: '100%', padding: '10px' }"
              >
                <div class="w-100">
                  <div class="w-100 tc fz-20">2级</div>
                  <div class="w-100 tc fz-14">现场风速</div>
                </div>
              </el-card>
            </el-col>
          </el-row>
          <div class="right-bottom-border"></div>
        </div>
        <div class="data-title position-relative">
          <div class="left-top-border"></div>
          <div class="fz-14 text-color-white m-t-10 p-l-20">报警统计</div>
        </div>
        <div class="alarm-statistics w-100 p-10 position-relative">
          <v-chart class="w-100 h-100" :options="alarmStatisticsOption"></v-chart>
          <div class="right-bottom-border"></div>
        </div>
        <div class="data-title position-relative">
          <div class="left-top-border"></div>
          <div class="fz-14 text-color-white m-t-10 p-l-20">系统状态统计</div>
        </div>
        <div class="status-statistics w-100 p-10 position-relative">
          <div class="d-flex flex-row-between status-icon">
            <i class="iconfont icon-bg-lighting fz-20 text-color-blue"></i>
            <i class="iconfont icon-bg-lock fz-20 text-color-blue"></i>
            <i class="iconfont icon-bg-fan fz-20 text-color-blue"></i>
            <i class="iconfont icon-bg-monitor fz-20 text-color-blue"></i>
            <i class="iconfont icon-bg-lighting1 fz-20 text-color-white"></i>
            <i class="iconfont icon-walk fz-20 text-color-white"></i>
          </div>
          <div class="d-flex flex-row-between status-icon">
            <i class="iconfont icon-bg-volume fz-20 text-color-red"></i>
            <i class="iconfont icon-water-logging fz-20 text-color-white"></i>
            <i class="iconfont icon-bg-firecontrol fz-20 text-color-red"></i>
            <i class="iconfont icon-o2 fz-22 text-color-white"></i>
            <i class="iconfont icon-o3 fz-22 text-color-white"></i>
            <i class="iconfont icon-bg-sf61 fz-22 text-color-white"></i>
          </div>
          <div class="status-chart">
            <v-chart class="w-100 h-100" :options="statusOption"></v-chart>
          </div>
          <div class="right-bottom-border"></div>
        </div>
      </div>
    </div>
    <div
      class="h-100 position-absolute measure_point p-10"
      id="history"
      v-if="showHistoryData"
      v-drag
      :body-style="{ padding: '10px' }"
      :style="{ left: isShowBasicCom ? '405px' : '35px' }"
    >
      <el-row class="c-white business_dialog_title m-b-5">
        <el-col :span="12" class="fz-14">测点历史数据</el-col>
        <el-col :span="12">
          <i @click="showHistoryData = false" class="cur_pointer fz-12 iconfont icon-close r"></i>
        </el-col>
      </el-row>
      <el-card class="w-100" :body-style="{ height: '100%' }">
        <!-- 时间 -->
        <el-row class="flex-align-center d-flex">
          <el-col :span="18">
            <el-date-picker
              class="time w-100"
              type="daterange"
              v-model="dateTimes"
              size="mini"
              popper-class="document_select-popper"
              range-separator="~"
              value-format="yyyy-MM-dd"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
            ></el-date-picker>
          </el-col>
          <el-col :span="6" class="tr">
            <el-button
              size="mini"
              type="primary"
              icon="iconfont icon-search"
              data-cy="searchBtn"
              @click="searchHistoryData"
              >搜索</el-button
            >
          </el-col>
        </el-row>
        <!-- echarts -->
        <div class="w-100 flex charts position-relative">
          <v-chart
            :options="historyChart"
            :autoresize="false"
            class="h-100"
            theme="macarons"
            id="history-chart"
          />
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
import ApiMixinPoint from '@/assets/js/api/measuringPoint'

export default {
  name: 'DataMonitoring',
  components: {},
  mixins: [ApiMixinPoint],
  props: ['documentId', 'player', 'height', 'top', 'isShowBasicCom'],
  data() {
    const myData = [
      { value: 14, name: '正常设备' },
      { value: 16, name: '故障设备' },
      { value: 4, name: '告警设备' },
    ]
    return {
      showHistoryData: false,
      dateTimes: [],
      historyChart: {
        color: [
          '#409eff',
          '#f56c6c',
          '#e6a23c',
          '#fac858',
          '#ee6666',
          '#73c0de',
          '#3ba272',
          '#9a60b4',
          '#ea7ccc',
        ],
        dataZoom: [
          {
            type: 'inside',
            startValue: 0,
            endValue: 10,
          },
          {
            startValue: 0,
            endValue: 10,
            textStyle: {
              color: '#ffffff',
            },
          },
        ],
        title: {
          text: '测点历史数据',
          textStyle: {
            color: '#ffffff',
            fontSize: '12px',
          },
        },
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(255,255,255,0.7)',
          textStyle: {
            color: '#000',
          },
        },
        grid: {
          left: '6%',
          right: '5%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: [],
          axisLine: {
            lineStyle: {
              color: '#ffffff',
            },
          },
          axisLabel: {
            interval: 0,
            rotate: 20,
            textStyle: {
              color: '#ffffff',
            },
          },
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            textStyle: {
              color: '#ffffff',
            },
          },
          axisLine: {
            lineStyle: {
              color: '#ffffff',
            },
          },
        },
        series: [],
      },
      alarmStatisticsOption: {
        color: [
          '#409eff',
          '#f56c6c',
          '#e6a23c',
          '#fac858',
          '#ee6666',
          '#73c0de',
          '#3ba272',
          '#9a60b4',
          '#ea7ccc',
        ],
        tooltip: {
          trigger: 'item',
        },
        legend: {
          top: 'center',
          right: '0',
          orient: 'vertical',
          textStyle: {
            color: '#ffffff',
          },
          formatter: (name) => {
            const current = _.find(myData, ['name', name])
            return `${name}:${current.value}个`
          },
          itemGap: 35,
        },
        grid: {
          left: 0,
        },
        series: [
          {
            name: '报警统计',
            type: 'pie',
            radius: ['55%', '85%'],
            avoidLabelOverlap: false,
            center: ['30%', '50%'],
            label: {
              show: false,
              position: 'center',
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 14,
                textColor: '#ffffff',
                formatter: '{d}%\n{b}',
              },
            },
            labelLine: {
              show: false,
            },
            data: myData,
          },
        ],
      },
      statusOption: {
        color: [
          '#409eff',
          '#f56c6c',
          '#e6a23c',
          '#909399',
          '#ee6666',
          '#73c0de',
          '#3ba272',
          '#9a60b4',
          '#ea7ccc',
        ],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // Use axis to trigger tooltip
            type: 'shadow', // 'shadow' as default; can also be 'line' or 'shadow'
          },
        },
        legend: {
          textStyle: {
            color: '#ffffff',
          },
        },
        grid: {
          top: '12%',
          left: '3%',
          right: '5%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'value',
          axisLabel: {
            labelStyle: {
              color: '#ffffff',
            },
          },
          axisLine: {
            lineStyle: {
              color: '#ffffff',
            },
          },
        },
        yAxis: {
          axisLabel: {
            labelStyle: {
              color: '#ffffff',
            },
          },
          axisLine: {
            lineStyle: {
              color: '#ffffff',
            },
          },
          type: 'category',
          data: [
            '照明设备',
            '门禁设备',
            '风机设备',
            '监控设备',
            '防潮灯',
            '红外双鉴噪声',
            '水浸',
            '烟感',
            '氧气',
            '臭氧',
            '六氟化硫',
          ],
        },
        dataZoom: [
          {
            id: 'dataZoomY',
            show: true,
            width: 20,
            yAxisIndex: [0],
            startValue: 0,
            endValue: 5,
            borderColor: 'white',
            showDetail: false,
            textStyle: {
              color: '#ffffff',
            },
          },
        ],
        series: [
          {
            name: '正常',
            type: 'bar',
            stack: 'total',
            label: {
              show: true,
            },
            emphasis: {
              focus: 'series',
            },
            data: [10, 15, 20, 18, 16, 30, 28, 12, 14, 15, 24],
          },
          {
            name: '报警',
            type: 'bar',
            stack: 'total',
            label: {
              show: true,
            },
            emphasis: {
              focus: 'series',
            },
            data: [2, 1, 0, 1, 2, 3, 4, 1, 0, 2, 1],
          },
          {
            name: '故障',
            type: 'bar',
            stack: 'total',
            label: {
              show: true,
            },
            emphasis: {
              focus: 'series',
            },
            data: [0, 1, 1, 2, 1, 0, 0, 1, 2, 1, 0],
          },
          {
            name: '离线',
            type: 'bar',
            stack: 'total',
            label: {
              show: true,
            },
            emphasis: {
              focus: 'series',
            },
            data: [5, 4, 1, 0, 2, 1, 3, 4, 2, 1, 5],
          },
        ],
      },
      markerList: [],
      measurePointList: [],
      updateTimer: null,
    }
  },
  async created() {
    await this.getMeasurePoints()
    this.player.Native.GisMarker.EventGisMarkerLClick.connect(this.clickMarker)
  },
  computed: {
    currentProject() {
      return this.$store.getters.currentProject || {}
    },
  },
  watch: {},
  beforeDestroy() {
    this.clearMarker()
  },
  methods: {
    // 搜索测点历史数据
    searchHistoryData() {
      this.historyChart.xAxis.data = []
      if (this.dateTimes && this.dateTimes.length >= 2) {
        for (let i = 0; i <= moment(this.dateTimes[1]).diff(this.dateTimes[0], 'days'); i += 1) {
          this.historyChart.xAxis.data.push(
            moment(this.dateTimes[0])
              .add(i, 'days')
              .format('MM-DD')
          )
        }
      }
      this.historyChart.series = _.map(this.relatinPoints, (item) => {
        const historyData = _.map(this.historyChart.xAxis.data, (e) => {
          return _.random(50, 300)
        })
        return {
          id: item.id,
          name: `${item.tagCode}-${item.name}(单位:${item.unit || ''})`,
          type: 'line',
          symbolSize: [8, 8],
          data: historyData,
          max: _.max(historyData),
          min: _.min(historyData),
          average: _.mean(historyData).toFixed(2),
        }
      })
    },
    // 清除标记
    async clearMarker() {
      _.forEach(this.markerList, async (item) => {
        if (item.markerId) {
          await this.player.Native.GisMarker.destroy(item.markerId)
          item.markerId = null
        }
      })
      this.player.Native.GisMarker.EventGisMarkerLClick.disconnect(this.clickMarker)
      clearInterval(this.updateTimer)
    },
    // 点击标签
    async clickMarker(e) {
      const info = _.find(this.markerList, ['markerId', e.markerId])
      if (info && info.code) {
        const nodeInfo = await this.player.Native.ModelTree.getItemByCode(info.code)
        if (nodeInfo) {
          await this.player.Native.ModelTree.setSelectItem(nodeInfo.item)
          const calcData = await this.player.Native.ModelTree.calcItemAabb(nodeInfo.item)
          this.player.Native.Camera.moveToAabb(calcData.aabb, calcData.localMatrix, 5, 1.1, 2)
        }
      }
      this.relatinPoints = info.pointList
      this.dateTimes = [
        moment()
          .subtract(7, 'd')
          .format('YYYY-MM-DD'),
        moment().format('YYYY-MM-DD'),
      ]
      this.searchHistoryData()
      this.showHistoryData = true
    },
    // 关闭弹窗
    closeComponent() {
      this.$emit('closeComponent', 'DataMonitoring')
    },
    // 绘制标签
    async drawMarker(code, pos, imgId, textList, pointList) {
      const text = textList.join('\n')
      const maxLength = _.max(textList, (item) => {
        return item.length
      })
      const option = {
        pos, // 定位点，世界坐标，三维向量
        text, // 文本
        visible: true, // 显示隐藏状态
        size: -1, // 整体尺寸，二维向量，-1表示不限制，自动大小
        nodeOffset: [(-1 * maxLength.length * 18) / 2, (-1 * textList.length * 18) / 2], // 相对定位点的偏移量，二维向量
        imgId, // 图片
        imgSize: [-1, -1], // 图片尺寸，-1为应用图片大小，如[32, -1]为宽度拉伸或压缩到32，高度为图片高度
        imgOffset: [0, 0], // 图片相对标记的偏移量
        fontSize: 18.0, // 字体大小
        breakWidth: -1, // 最大行宽，超过宽度会换行，-1表示限制，换行符（'\n'）会强制换行不受控制
        contentPadding: [10, 10, 10, 10], // 文字相对标记的偏移量
        textColor: 0xffffffff, // 文本颜色
        title: '', // 标题
        titleFontSize: 18.0, // 标题文字大小
        titleColor: 0xffffffff, // 标题颜色
        userData: null, // 用户数据，仅帮外部系统保存数据
      }
      const markerId = await this.player.Native.GisMarker.create(option)
      this.markerList.push({ code, markerId, pointList })
    },
    // 获取所有测点
    async getMeasurePoints() {
      const params = {
        siteId: this.currentProject.id,
        bind: true,
        pageno: 1,
        pagesize: 9999,
      }
      const res = await this.apiPoint({
        method: 'list',
        params,
      })
      if (res && res.code === 0 && res.data) {
        this.measurePointList = res.data
        const tagCodeList = _.uniq(_.map(res.data, 'tagCode'))
        const imgId = await this.player.Native.GisMarker.loadImage(
          `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/img/tag_info.png`
        )
        for (let x = 0; x < tagCodeList.length; x += 1) {
          const item = tagCodeList[x]
          const pointList = _.filter(res.data, (el) => {
            return el.tagCode === item
          })
          // eslint-disable-next-line no-await-in-loop
          const aabbData = await this.player.Native.ModelTree.calcItemAabb(item)
          if (!_.isEmpty(aabbData)) {
            const pos = [
              1 * aabbData.aabb.min[0] + (aabbData.aabb.max[0] - aabbData.aabb.min[0]) / 2,
              1 * aabbData.aabb.min[1] + (aabbData.aabb.max[1] - aabbData.aabb.min[1]) / 2,
              1 * aabbData.aabb.max[2],
            ]
            // eslint-disable-next-line no-loop-func
            const textList = _.map(pointList, (i) => {
              return `${i.code}:${_.random(i.lowerLimit, i.upperLimit, true).toFixed(1)}${i.unit}`
            })
            const markerText = [`设备名称:${item}`, ...textList, ' ', ' ']
            // eslint-disable-next-line no-await-in-loop
            await this.drawMarker(item, pos, imgId, markerText, pointList)
          }
        }
        this.updateTimer = setInterval(() => {
          this.updateMarker()
        }, 5000)
      }
    },
    // 更新标签文本内容
    async updateMarker() {
      const tagCodeList = _.uniq(_.map(this.measurePointList, 'tagCode'))
      for (let x = 0; x < tagCodeList.length; x += 1) {
        const item = tagCodeList[x]
        const pointList = _.filter(this.measurePointList, (el) => {
          return el.tagCode === item
        })
        // eslint-disable-next-line no-loop-func
        const textList = _.map(pointList, (i) => {
          return `${i.code}:${_.random(i.lowerLimit, i.upperLimit, true).toFixed(1)}${i.unit}`
        })
        const markerText = [`设备名称:${item}`, ...textList, ' ', ' ']
        // eslint-disable-next-line no-await-in-loop
        const text = markerText.join('\n')
        const maxLength = _.max(markerText, (el) => {
          return el.length
        })
        const option = {
          text, // 文本
          nodeOffset: [(-1 * maxLength.length * 18) / 2, (-1 * markerText.length * 18) / 2], // 相对定位点的偏移量，二维向量
        }
        const currentMarker = _.find(this.markerList, ['code', item])
        if (currentMarker && currentMarker.markerId) {
          // eslint-disable-next-line no-await-in-loop
          await this.player.Native.GisMarker.update(currentMarker.markerId, option)
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>

@import '../../css/select.scss';
@import '../../css/index.scss';
.content {
  overflow: auto;
}
.data-title {
  height: 40px;
  background-color: rgb(11, 44, 108);
  line-height: 40px;
  .icon-close {
    top: -10px;
    right: 3px;
  }
}
.left-top-border {
  height: 40px;
  width: 88px;
  position: absolute;
  left: 0;
  top: 0;
  background-image: url('/static/img/mk/left_top.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.right-bottom-border {
  height: 40px;
  width: 88px;
  position: absolute;
  right: 0;
  bottom: 0;
  background-image: url('/static/img/mk/right_bottom.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
#data-monitoring {
  width: 368px;
  right: 35px;
  border-radius: 2px;
  z-index: 99;
  transition: left 0.3s;
  background-color: rgba(46, 107, 176, 0.5) !important;
  z-index: 99;
  .env-monitoring {
    background-color: rgba(24, 41, 72, 0.85);
    height: 140px;
  }
  .alarm-statistics {
    background-color: rgba(24, 41, 72, 0.85);
    height: 153px;
  }
  .status-statistics {
    background-color: rgba(24, 41, 72, 0.85);
    height: 315px;
    .status-icon {
      padding: 0 20px;
      height: 36px;
    }
    .status-chart {
      height: calc(100% - 72px);
    }
  }
}
.field-temp {
  color: #ffffff;
  /deep/.el-card__body {
    background-color: rgba(1, 255, 237, 0.76);
    display: flex;
    align-items: center;
  }
}
.field-humidity {
  color: #ffffff;
  /deep/.el-card__body {
    background-color: rgba(112, 166, 219, 0.88);
    display: flex;
    align-items: center;
  }
}
.field-wind-speed {
  color: #ffffff;
  /deep/.el-card__body {
    background-color: rgb(255, 200, 22);
    display: flex;
    align-items: center;
  }
}
.text-color-red {
  color: red;
}
.measure_point {
  background-color: rgba(46, 107, 176, 0.5) !important;
}
#history {
  height: 398px;
  width: 600px;
  left: 408px;
  top: 66px;
  border-radius: 4px;
  z-index: 1001;
  .time {
    width: 100%;
    margin: 10px 0;
  }
  .charts {
    height: 300px;
    padding: 5px;
    background-color: rgba(24, 41, 72, 0.5) !important;
  }
  /deep/ .el-table th.gutter {
    display: table-cell !important;
  }
}
.close-btn {
  top: 5px;
  right: 5px;
  z-index: 9999;
}
/deep/.el-card {
  height: calc(100% - 30px);
  &__body {
    padding: 0px !important;
    border-radius: 2px;
  }
}
/deep/ .el-date-editor .el-range-input {
  color: #ffffff;
  background-color: transparent;
}
/deep/ .el-range-editor--mini .el-range-separator {
  color: #ffffff;
}

</style>
